// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import BurgerController from "./burger_controller"
application.register("burger", BurgerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileAutoSubmitController from "./file_auto_submit_controller"
application.register("file-auto-submit", FileAutoSubmitController)

import Dialog from "@stimulus-components/dialog"
application.register("dialog", Dialog)

import TiptapEditorController from "./tiptap_editor_controller"
application.register("tiptap-editor", TiptapEditorController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AiTranslationController from "./ai_translation_controller"
application.register("ai-translation", AiTranslationController)

import CategoryManagerController from "./category_manager_controller"
application.register("category-manager", CategoryManagerController)

import CoverImageUploadController from "./cover_image_upload_controller"
application.register("cover-image-upload", CoverImageUploadController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import TitleFieldController from "./title_field_controller"
application.register("title-field", TitleFieldController)

import SuggestionManagerController from "./suggestion_manager_controller"
application.register("suggestion-manager", SuggestionManagerController)

import ScheduleManagerController from "./schedule_manager_controller"
application.register("schedule-manager", ScheduleManagerController)

import ReadingProgressController from "./reading_progress_controller"
application.register("reading-progress", ReadingProgressController)

import CollapsibleSidebarController from "./collapsible_sidebar_controller"
application.register("collapsible-sidebar", CollapsibleSidebarController)

import EditorMobileSidebarsController from "./editor_mobile_sidebars_controller"
application.register("editor-mobile-sidebars", EditorMobileSidebarsController)

import PublishGuardController from "./publish_guard_controller"
application.register("publish-guard", PublishGuardController)
